module.exports = __webpack_public_path__ + "img/remove_red_eye.ff445ac4.svg";